export const sentenceCase = (word: string) => {
  if (!word) {
    return '';
  }
  const withSpaces = word.replace(/([A-Z])/g, ' $1');
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1).toLowerCase();
};
